import EmptyState from "@common/emptyState"
import { useState } from "react"
import EntitySearchModal from "components/entitySearchModal"

export default function EntitySelectorEmptyUnit({useDefaultReport = true}) {
  const [isEntityModalOpen, setIsEntityModalOpen] = useState(false)
  return (
    <>
      <EmptyState
        // icon={"new-folder"}
        title={"No Entity Selected"}
        subTitle={"Select any added entity to see the report."}
        primaryActionBtnText={"Select Entity"}
        onPrimaryActionClick={() => setIsEntityModalOpen(true)}
      />
      <EntitySearchModal
        wrapInLink={true}
        entityUnitMode="fetch"
        isOpen={isEntityModalOpen}
        useDefaultReport={useDefaultReport}
        onClose={() => setIsEntityModalOpen(false)}
        customTrigger={<div></div>}
      />
    </>
  )
}
